<template>
  <div style="margin: 0 24px;">
    <el-form ref="formRef" :model="roleForm" label-width="90px" label-position="right">
      <el-form-item label="角色类型：">
        <el-select v-model="positionType" placeholder="请选择" style="width: 100%; margin-right: 16px;">
          <el-option v-for="item in positionTypeArray" :key="item.positionType" :label="item.name" :value="item.positionType">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="角色名称：">
        <el-input v-model="roleForm.name" placeholder="请输入角色名称" style="margin-right: 16px;"/>
      </el-form-item>
      <el-form-item label="角色权限：">
        <div class="dialog-main">
          <div class="dialog-main-tiem" style="padding: 16px">
            <div style="display: flex;flex-wrap: wrap;">
              <div style="width: 50%; margin-bottom: 12px;">
                <label>客户回访：</label>
                <el-select v-model="visitState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 2) != 2 && userName != 'root'">
                  <el-option v-for="item in visitStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="width: 50%; margin-bottom: 12px;">
                <label>商品库存：</label>
                <el-select v-model="stockState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 4) != 4 && userName != 'root'">
                  <el-option v-for="item in stockStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="width: 50%; margin-bottom: 12px;">
                <label>微信绑定：</label>
                <el-select v-model="wechatState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 8) != 8 && userName != 'root'">
                  <el-option v-for="item in wechatStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="width: 50%; margin-bottom: 12px;">
                <label>预约状态：</label>
                <el-select v-model="bookState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 16) != 16 && userName != 'root'">
                  <el-option v-for="item in bookStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="width: 50%; margin-bottom: 12px;" >
                <label>卫生审核：</label>
                <el-select v-model="hygieneState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 32) != 32 && userName != 'root'">
                  <el-option v-for="item in hygieneStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="width: 50%; margin-bottom: 12px;">
                <label>上传卫生照片：</label>
                <el-select v-model="hygieneImgState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 64) != 64 && userName != 'root'">
                  <el-option v-for="item in hygieneImgStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="width: 50%; margin-bottom: 12px;">
                <label>编辑消费单：</label>
                <el-select v-model="editBookState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 128) != 128 && userName != 'root'">
                  <el-option v-for="item in editBookStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="width: 50%; margin-bottom: 12px;">
                <label>编辑充值记录：</label>
                <el-select v-model="editRechargeState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 256) != 256 && userName != 'root'">
                  <el-option v-for="item in editRechargeStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="width: 50%">
                <label>打款状态：</label>
                <el-select v-model="editPaymentState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 512) != 512 && userName != 'root'">
                  <el-option v-for="item in editPaymentStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
              <div style="width: 50%; margin-bottom: 12px;">
                <label>赠送金额限制：</label>
                <el-select v-model="editGiveNumState" value-key="value" placeholder="请选择"  style="width: 12em;" :disabled="(operateStateUser & 1024) != 1024 && userName != 'root'">
                  <el-option v-for="item in editGiveNumStateList" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
        </div>
      </el-form-item>
      <el-form-item label="角色权限：">
        <div class="dialog-main">
          <div class="dialog-main-tiem">
            <div class="item-title">
              <div>
                <el-button type="text" @click="allChecked">全选</el-button>
                <el-button type="text" @click="notChecked">全不选</el-button>
              </div>
            </div>
            <el-scrollbar max-height="500px" class="item-tree">
              <el-tree default-expand-all :data="dataArray" show-checkbox node-key="id" ref="tree" :default-checked-keys="defaultChecked" :props="defaultProps" style="line-height: 26px;">

                <template #default="{ node, data }">

                  <span class="custom-tree-node">
                    <span>{{ node.label }}</span>
                  </span>

                  <span v-if="!data.children">
                    <el-checkbox v-model="data.lockState" :true-label="1" :false-label="0"><span style="white-space: nowrap">上锁</span></el-checkbox>
                  </span>

                </template>

              </el-tree>
            </el-scrollbar>
          </div>

        </div>
      </el-form-item>
      <el-form-item label="解锁密码：">
        <el-input v-model="unlockPwd" placeholder="请输入6位数字" style="margin-right: 16px;"/>
      </el-form-item>
      <el-form-item label="失效时间：">
        <el-input v-model="expireTime" placeholder="请输入1-120之间的失效时间" style="margin-right: 16px;"/>
        <span style="color: red; font-size: 12px">*以分钟为单位</span>
      </el-form-item>
<!--      <el-form-item label="">-->
<!--        <el-checkbox v-model="roleForm.goodsManagerState" :true-label="1" :false-label="0"><span style="white-space: nowrap">允许添加门店商品的出入库记录</span></el-checkbox>-->
<!--      </el-form-item>-->
    </el-form>
    <div class="dialog-footer" style="text-align: center; margin: 8px 0;">
      <el-button @click.native="cancel" >取消</el-button>
      <el-button type="primary" @click="submit">提交</el-button>
    </div>
  </div>

</template>

<script>
import {postJson, postFormData, getFormData} from "@/api/api"
import {menuList, addOrUpdateRoleMenu, getAllChannelPackageList, listFilterSysRole} from "@/api/url";
import {positiveIntReg} from "@/assets/shared/reg-constant";

export default {
name: "UserFromDialog",
  props: {
    value: Object
  },
  data() {
   return {
     roleForm: this.value.roleForm,
     idx: this.value.idx,

     positionTypeArray: [],
     positionType: '',

     //管理目录
     dataArray: [],
     defaultProps: {
       children: 'children',
       label: 'name'
     },
     defaultChecked:[],

     //渠道包名
     channelArray: [],
     defaultChannelProps: {
       children: 'channelList',
       label: 'name'
     },
     defaultChannelChecked:[],

     // operateState: this.value.roleForm.operateState,
     //
     // operateGoldList: [
     //   {label: '不可操作', value: 0},
     //   {label: '可操作', value: 2},
     // ],
     // operateGold: this.value.roleForm.operateState == 0?0:this.value.roleForm.operateState == 2?2:this.value.roleForm.operateState == 4?0:this.value.roleForm.operateState == 6?2:0,
     //
     // operateResumeList: [
     //   {label: '不可操作', value: 0},
     //   {label: '可操作', value: 4},
     // ],
     // operateResume: this.value.roleForm.operateState == 0?0:this.value.roleForm.operateState == 2?0:this.value.roleForm.operateState == 4?4:this.value.roleForm.operateState == 6?4:0,

     sysTimeList: [
       {label: '不限', value: 0},
       {label: '1个月', value: 1},
       {label: '2个月', value: 2},
       {label: '3个月', value: 3},
       {label: '6个月', value: 6},
       {label: '1年', value: 12},
       {label: '2年', value: 24},
     ],
     sysTime: 0,
     isSuper: 0,

     unlockPwd: this.value.roleForm.unlockPwd?this.value.roleForm.unlockPwd:'654321',
     expireTime: this.value.roleForm.expireTime?this.value.roleForm.expireTime:30,

     // operateState:0,
     visitState: 0,
     visitStateList: [
       {label:'无审核权限', value: 0},
       {label:'有审核权限', value: 2}
     ],

     stockState: 0,
     stockStateList: [
       {label:'不可修改库存', value: 0},
       {label:'可修改库存', value: 4}
     ],

     wechatState: 0,
     wechatStateList: [
       {label:'不可解除绑定', value: 0},
       {label:'可解除绑定', value: 8}
     ],

     bookState: 0,
     bookStateList: [
       {label:'不可修改预约状态', value: 0},
       {label:'可修改预约状态', value: 16}
     ],

     hygieneState: 0,
     hygieneStateList: [
       {label:'无审核权限', value: 0},
       {label:'有审核权限', value: 32}
     ],

     hygieneImgState: 0,
     hygieneImgStateList: [
       {label:'不可上传卫生照片', value: 0},
       {label:'可上传卫生照片', value: 64}
     ],

     editBookState: 0,
     editBookStateList: [
       {label:'有时间限制', value: 0},
       {label:'无时间限制', value: 128}
     ],

     editRechargeState: 0,
     editRechargeStateList: [
       {label:'有时间限制', value: 0},
       {label:'无时间限制', value: 256}
     ],

     editPaymentState: 0,
     editPaymentStateList: [
       {label:'不可修改', value: 0},
       {label:'可修改', value: 512}
     ],

     editGiveNumState: 0,
     editGiveNumStateList: [
       {label:'有限制', value: 0},
       {label:'没有限制', value: 1024}
     ],

     operateStateUser: JSON.parse(sessionStorage.getItem('operateState')),
     userName: JSON.parse(sessionStorage.getItem('account'))

   }
  },

  computed: {
    operateState() {
      return this.visitState + this.stockState + this.wechatState + this.bookState + this.hygieneState + this.hygieneImgState + this.editBookState + this.editRechargeState + this.editPaymentState  + this.editGiveNumState
    }
  },

  methods: {

    // lockChange(data) {
    //   // console.log(data)
    //   this.dataArray.map(item => {
    //     if(item.id == data.id && item.children.length > 0) {
    //       item.children.map(e => {
    //         e.lockState = data.lockState
    //       })
    //     }
    //   })
    // },

    cancel() {
      this.$emit("close");
    },
    notChecked() {
      this.$refs.tree.setCheckedKeys([]);
    },
    allChecked() {
      this.$refs.tree.setCheckedNodes(this.dataArray);
    },

    notChannelChecked() {
      this.$refs.channelTree.setCheckedKeys([]);
    },
    allChannelChecked() {
      this.$refs.channelTree.setCheckedNodes(this.channelArray);
    },

    submit() {
      if(!this.roleForm.name) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '角色名称不能为空',
          type: 'warning'
        });
        return false
      }
      if(!this.unlockPwd) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入6个数字密码',
          type: 'warning'
        });
        return false
      }
      if(!this.expireTime) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入1-120之间的失效时间',
          type: 'warning'
        });
        return false
      }else if(!positiveIntReg.test(this.expireTime)) {
        this.$message({
          showClose: true,
          duration: 2000,
          message: '请输入1-120之间的失效时间',
          type: 'warning'
        });
        return false
      }
      let _this = this;
      let checkIds = this.getChecked();
      // let channelCheckIds = this.getChannelChecked()
      let param = {}
      param['id'] = this.roleForm.id;
      param['positionType'] = this.positionType;
      param['name'] = this.roleForm.name;
      param['menuIdArr'] = checkIds;
      param['unlockPwd'] = this.unlockPwd
      param['expireTime'] = Number(this.expireTime);
      param['operateState'] = this.operateState;
      // param['goodsManagerState'] = this.roleForm.goodsManagerState;
      postJson(addOrUpdateRoleMenu, param).then((data) => {
        let { code, msg } = data;
        if (code == 200) {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'success'
          })
          _this.$emit('confirm')
        } else {
          _this.$message({
            showClose: true,
            duration: 1000,
            message: msg,
            type: 'warning'
          })
        }
      })
    },

    //获取管理员权限
    // getMenuList(account) {
    //   let _this = this;
    //   getFormData(menuList, {}).then((data) => {
    //     let code = data.code;
    //     if(code == 200) {
    //       _this.isSuper = account.isSuper;
    //       _this.sysTime = account.duration;
    //       _this.powerList = data.data;
    //       _this.dataArray = this.formatList(this.powerList, 0);
    //       // console.log(_this.dataArray)
    //       let ids = [];
    //       if(account.sysMenuList) {
    //         account.sysMenuList.map(item => {
    //           ids.push(item.id)
    //         })
    //       }
    //       _this.defaultChecked = _this.getDefaultChecked(ids, _this.dataArray);
    //       _this.account = account;
    //     } else {
    //       _this.$message({
    //         showClose: true,
    //         duration: 1000,
    //         message: '获取失败',
    //         type: 'warning'
    //       })
    //     }
    //   })
    // },

    getMenuList() {
      this.dataArray = JSON.parse(localStorage.getItem('menuLockList'));
      this.defaultChecked = this.getDefaultChecked(this.roleForm.menuList, this.dataArray);
      if(this.idx > -1) {
        this.getDefaultLockState(this.roleForm.menuList, this.dataArray);
      }else {
        this.dataArray.map(item => {
          item.lockState = 0
          if(item.children) {
            item.children.map(c => {
              c.lockState = 0
            })
          }
        })
      }
    },

    getDefaultLockState(array, dataArray) {
      for(let i=0; i<dataArray.length; i++) {
        for(let j=0; j<array.length; j++) {
          if(dataArray[i].id == array[j].id) {
            dataArray[i].lockState = array[j].lockState
          }
          if(dataArray[i].children && dataArray[i].children.length > 0) {
            this.getDefaultLockState(array, dataArray[i].children)
          }
        }
      }
    },

    formatList(list, preId) {
      let array = [];
      let _this = this;
      list.forEach(function(e) {
        if(e['preId'] == preId) {
          let children = _this.formatList(list, e['id']);
          if(children.length > 0) {
            e['children'] = children;
          }
          array.push(e);
        }
      });
      return array;
    },
    //获取默认选项
    getDefaultChecked(array, dataArray) {
      let ids = [];
      array.map(item => {
        ids.push(item.id)
      })
      for(let i = ids.length-1; i >= 0; i--) {
        dataArray.forEach((e) => {
          if(e.id == ids[i] && e.children != null) {
            // ids = this.getDefaultChecked(arr, e.children);
            ids.splice(i, 1);
          }
        })
      }
      return ids;
    },
    //获取提交参数
    getChecked() {
      let idArray = [];
      let array = this.$refs.tree.getCheckedNodes();
      console.log(array)
      array.forEach((e) => {
        let obj = {}
        obj.id = e.id
        obj.lockState = e.lockState
        idArray.push(obj)
        if(e.level == 2 && idArray.every(item => item.id != e.preId)) {
          let _obj = {}
          _obj.id = e.preId
          _obj.lockState = 0
          idArray.push(_obj)
        }
        // idArray = idArray.concat(this.getParentChecked(e))
      });
      return idArray;
    },
    //提交时获取父级的id
    // getParentChecked(el) {
    //   let array = [];
    //   if(el.level > 2) {
    //     array = array.concat(el.preId);
    //     this.dataArray.forEach((e) => {
    //       if(e.id == el.preId) {
    //         array = array.concat(this.getParentChecked(e));
    //       }
    //     })
    //   } else if(el.level == 2) {
    //     array = array.concat(el.preId);
    //   }
    //   return array;
    // },


    getChannelChecked() {
      let idArray = [];
      let array = this.$refs.channelTree.getCheckedNodes();
      array.forEach((e) => {
        if (!e.channelList) {
          idArray.push(e.id)
        }
      })
      return idArray
    },

    getSysRoleList() {
      getFormData(listFilterSysRole).then(data=> {
        if(data.code == 200) {
          this.sysRoleList = data.data
          this.sysRoleList.map(item => {
            let obj = {}
            obj.name = item.name
            obj.positionType = item.positionType
            this.positionTypeArray.push(obj)
          })
          if(this.idx > -1) {
            this.positionType = this.roleForm.positionType
          }else {
            this.positionType = this.positionTypeArray[0].positionType
          }
        }
      })
    },

  },
  mounted() {
    this.getSysRoleList()
    this.getMenuList()
    // this.getChannelPackageList(this.roleForm)
    this.visitState = this.roleForm.operateState & 2
    this.stockState = this.roleForm.operateState & 4
    this.wechatState = this.roleForm.operateState & 8
    this.bookState = this.roleForm.operateState & 16
    this.hygieneState = this.roleForm.operateState & 32
    this.hygieneImgState = this.roleForm.operateState & 64
    this.editBookState = this.roleForm.operateState & 128
    this.editRechargeState = this.roleForm.operateState & 256
    this.editPaymentState = this.roleForm.operateState & 512
    this.editGiveNumState = this.roleForm.operateState & 1024
  }
}
</script>

<style scoped>
.dialog-button {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}

.item-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  /*margin-bottom: 12px;*/
  border-bottom: 1px solid #ebeef5;
  padding-bottom: 4px;
  margin: 0 24px 12px;
  /*position: absolute;*/
  /*top: 10px;*/
  /*right: 24px;*/
  /*z-index: 9;*/
}

.item-tree {
  padding: 0 24px;
}

.item-title-tips {
  font-size: 12px;
  color: #aaaaaa;
  margin-bottom: 12px;
}

.dialog-main {
  display: flex;
  justify-content: space-between;
  width: 100%;
}


.item-title p {
  font-weight: bold;
  color: #222222;
}

.dialog-main-tiem {
  border: #ededed 1px solid;
  padding: 16px 0;
  width: 100%;
  margin-right: 16px;
  position: relative;
}

.item-last {
  margin-right: 0;
}

.custom-tree-node {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex: 1;
}

</style>
